import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import { TextInput as FlowBiteTextInput } from 'flowbite-react';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function isValidEmail(email) {
  var emailPattern = /^\S+@\S+\.\S+$/;
  return emailPattern.test(email);
}
export var EmailInput = function EmailInput(_ref) {
  var value = _ref.value,
      label = _ref.label,
      supportText = _ref.supportText,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      onChange = _ref.onChange,
      containerStyles = _ref.containerStyles,
      inputStyles = _ref.inputStyles,
      labelStyles = _ref.labelStyles,
      supportTextStyles = _ref.supportTextStyles,
      suffixIcon = _ref.suffixIcon,
      placeholder = _ref.placeholder,
      disabled = _ref.disabled,
      testId = _ref.testId,
      supportTextTestId = _ref.supportTextTestId,
      id = _ref.id,
      onBlur = _ref.onBlur;
  var isErrored = variant === 'error';
  var errorMessage = supportText || "L'email inserita non è valida, ricontrolla e riprova";
  return /*#__PURE__*/_jsxs(StyledContainer, {
    containerStyles: containerStyles,
    children: [label && /*#__PURE__*/_jsx(StyledLabel, {
      labelStyles: labelStyles,
      children: label
    }), /*#__PURE__*/_jsx(TextField, {
      onChange: onChange,
      onBlur: onBlur,
      value: value,
      variant: variant,
      inputStyles: inputStyles,
      rightIcon: isErrored && ErrorIcon || suffixIcon && suffixIcon || undefined,
      placeholder: placeholder,
      disabled: disabled,
      "data-cy": testId,
      id: id
    }), (supportText || errorMessage) && /*#__PURE__*/_jsx(StyledSupportText, {
      variant: variant,
      supportTextStyles: supportTextStyles,
      "data-cy": supportTextTestId,
      children: isErrored ? errorMessage : supportText
    })]
  });
};

var StyledContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "formemail-input__StyledContainer",
  componentId: "sc-24x3sh-0"
})(function (_ref2) {
  var containerStyles = _ref2.containerStyles;
  return [{
    "display": "flex",
    "flexDirection": "column"
  }].concat(_toConsumableArray(containerStyles || []));
});

var StyledLabel = /*#__PURE__*/_styled.p.withConfig({
  displayName: "formemail-input__StyledLabel",
  componentId: "sc-24x3sh-1"
})(function (_ref3) {
  var labelStyles = _ref3.labelStyles;
  return [{
    "marginBottom": "0.5rem",
    "fontSize": "1rem",
    "lineHeight": "1.5rem",
    "fontWeight": "600"
  }].concat(_toConsumableArray(labelStyles || []));
});

var TextField = /*#__PURE__*/_styled(FlowBiteTextInput).withConfig({
  displayName: "formemail-input__TextField",
  componentId: "sc-24x3sh-2"
})(["", " input{", " ", " ", " ", "}"], {
  "display": "flex",
  "flex": "1 1 0%",
  "--tw-bg-opacity": "1 !important",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity)) !important"
}, {
  "width": "100%",
  "borderRadius": "0.5rem",
  "borderWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(229 231 235 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1 !important",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity)) !important",
  "paddingLeft": "1rem",
  "paddingRight": "0.75rem",
  "fontSize": "1rem",
  "lineHeight": "1.25rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(107 114 128 / var(--tw-text-opacity))",
  "outline": "2px solid transparent",
  "outlineOffset": "2px",
  ":focus": {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(229 231 235 / var(--tw-border-opacity))",
    "outline": "2px solid transparent",
    "outlineOffset": "2px"
  }
}, function (_ref4) {
  var variant = _ref4.variant;
  return variant === 'primary' ? {
    "::placeholder": {
      "--tw-text-opacity": "1",
      "color": "rgb(156 163 175 / var(--tw-text-opacity))"
    }
  } : {};
}, function (_ref5) {
  var variant = _ref5.variant;
  return variant === 'error' ? {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(204 0 34 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1 !important",
    "backgroundColor": "rgb(250 230 233 / var(--tw-bg-opacity)) !important",
    "--tw-text-opacity": "1",
    "color": "rgb(145 0 24 / var(--tw-text-opacity))",
    "::placeholder": {
      "--tw-text-opacity": "1",
      "color": "rgb(145 0 24 / var(--tw-text-opacity))"
    }
  } : {};
}, function (_ref6) {
  var inputStyles = _ref6.inputStyles;
  return inputStyles || [];
});

var StyledSupportText = /*#__PURE__*/_styled.p.withConfig({
  displayName: "formemail-input__StyledSupportText",
  componentId: "sc-24x3sh-3"
})(function (_ref7) {
  var supportTextStyles = _ref7.supportTextStyles,
      variant = _ref7.variant;
  return [{
    "marginTop": "0.75rem",
    "fontSize": "0.875rem",
    "lineHeight": "1.313rem",
    "fontWeight": "400",
    "--tw-text-opacity": "1",
    "color": "rgb(107 114 128 / var(--tw-text-opacity))"
  }, variant === 'error' && {
    "--tw-text-opacity": "1",
    "color": "rgb(186 0 31 / var(--tw-text-opacity))"
  }].concat(_toConsumableArray(supportTextStyles || []));
});

var ErrorIcon = /*#__PURE__*/_styled(ExclamationCircleIcon).withConfig({
  displayName: "formemail-input__ErrorIcon",
  componentId: "sc-24x3sh-4"
})(function () {
  return {
    "--tw-text-opacity": "1",
    "color": "rgb(145 0 24 / var(--tw-text-opacity))"
  };
});